import { render, staticRenderFns } from "./Film.vue?vue&type=template&id=d3935974&scoped=true&"
import script from "./Film.vue?vue&type=script&lang=js&"
export * from "./Film.vue?vue&type=script&lang=js&"
import style0 from "./Film.vue?vue&type=style&index=0&id=d3935974&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3935974",
  null
  
)

export default component.exports